import { Injectable } from '@angular/core';
import { CanActivate, CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from "@node_modules/@angular/router";
import { Observable, map } from "rxjs";
import { AppComponentBase } from "@shared/common/app-component-base";
import { ApplicationService } from "../application/application.service";
import { EraService } from "./era.service";

@Injectable()
export class EraGuard implements CanActivate, CanDeactivate<AppComponentBase> {

    constructor(
        private eraService: EraService,
        private applicationService: ApplicationService,
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
       return this.eraService.getEra(this.applicationService.caseId).pipe(map(() => true));
    }

    canDeactivate(component: AppComponentBase): boolean | Observable<boolean> {
        this.eraService.closeEra();
        return true;
    }
}
